var render = function render(){
  var _vm$newConfig$RightSi, _vm$activeContent$sub, _vm$newConfig$general, _vm$newConfig$general2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('transition', {
    attrs: {
      "name": "slide-in-left"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$store.state.isBottomBarVisible,
      expression: "$store.state.isBottomBarVisible"
    }],
    staticClass: "right-sidebar",
    class: [{
      'dir-rtl': _vm.language.dir === 'rtl'
    }, {
      'right-sidebar--subnav': _vm.newConfig.general.useSidebarSubnavigation
    }],
    style: "\n        background: ".concat((_vm$newConfig$RightSi = _vm.newConfig.RightSidebar) === null || _vm$newConfig$RightSi === void 0 ? void 0 : _vm$newConfig$RightSi['background-colour'], ";\n      "),
    attrs: {
      "dir": _vm.language.dir
    },
    on: {
      "click": _vm.clearTimeout
    }
  }, [_vm.config.generalSidebarBrandLogo ? _c('div', {
    staticClass: "right-sidebar__brand-logo"
  }, [_vm.isVideo(_vm.config.generalSidebarBrandLogo) ? _c('video', {
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.config.generalSidebarBrandLogo),
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.config.generalSidebarBrandLogo),
      "alt": ""
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "right-sidebar__layout",
    class: {
      'right-sidebar__layout--subnav': _vm.newConfig.general.useSidebarSubnavigation
    }
  }, [_c('div', {
    staticClass: "right-sidebar__content"
  }, [_vm.showMinimapTop && _vm.activeContent.minimap ? _c('div', {
    staticClass: "right-sidebar__minimap-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "right-sidebar-minimap-crossfade"
    }
  }, [_c('img', {
    key: _vm.activeContent.minimap,
    staticClass: "right-sidebar__minimap",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.activeContent.minimap),
      "alt": ""
    }
  })])], 1) : _vm._e(), _c('div', {
    staticClass: "spacer"
  }), (_vm$activeContent$sub = _vm.activeContent.subsectionShortcuts) !== null && _vm$activeContent$sub !== void 0 && _vm$activeContent$sub.length ? _c('div', {
    key: "shortcuts",
    staticClass: "right-sidebar__shortcuts"
  }, _vm._l(_vm.activeContent.subsectionShortcuts, function (shortcut) {
    return _c('div', {
      key: shortcut.subsectionId,
      staticClass: "shortcut-wrapper"
    }, [_c('button', {
      key: shortcut.subsectionId,
      staticClass: "btn touch",
      on: {
        "click": function click($event) {
          return _vm.navigationToSubsection(shortcut.subsectionId);
        }
      }
    }, [_vm._v("\n                " + _vm._s(shortcut.label[_vm.language.code] || shortcut.label.en) + "\n              ")])]);
  }), 0) : _vm._e(), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [_vm.activeContent.heading ? _c('div', {
    key: _vm.activeContent.heading,
    staticClass: "right-sidebar__heading",
    domProps: {
      "innerHTML": _vm._s(_vm.activeContent.heading)
    }
  }) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [_vm.activeContent.description ? _c('div', {
    key: _vm.activeContent.description,
    staticClass: "right-sidebar__description",
    domProps: {
      "innerHTML": _vm._s(_vm.activeContent.description)
    }
  }) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [!_vm.showMinimapTop && _vm.activeContent.minimap ? _c('div', {
    staticClass: "right-sidebar__minimap-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "right-sidebar-minimap-crossfade"
    }
  }, [_c('img', {
    key: _vm.activeContent.minimap,
    staticClass: "right-sidebar__minimap",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.activeContent.minimap),
      "alt": ""
    }
  })])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [!_vm.newConfig.general.showProductCountWidget && _vm.newConfig.rightSidebar.propertyGuide.active && _vm.activeContent.markerGuide ? _c('MarkerGuide', {
    key: _vm.activeContent.markerGuide,
    staticClass: "right-sidebar__marker-guide"
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [_vm.activeContent.qrUrl ? _c('div', {
    key: _vm.activeContent.qrUrl,
    staticClass: "right-sidebar__qr-wrapper"
  }, [_c('div', {
    staticClass: "right-sidebar__qr"
  }, [_c('div', {
    staticClass: "right-sidebar__qr-row"
  }, [_c('qrcode-vue', {
    key: _vm.activeContent.qrUrl,
    staticClass: "qrcode",
    attrs: {
      "value": _vm.activeContent.qrUrl,
      "size": "1000",
      "renderAs": "canvas",
      "background": "transparent",
      "foreground": "#ffffff"
    }
  }), _c('div', {
    staticClass: "right-sidebar__qr-message"
  }, [_vm._v(_vm._s(_vm.activeContent.qrMessage[_vm.language.code] || _vm.activeContent.qrMessage.en))])], 1)])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [_vm.activeContent.virtualTourUrl ? _c('div', {
    key: _vm.activeContent.virtualTourUrl,
    staticClass: "right-sidebar__qr-wrapper"
  }, [_c('div', {
    staticClass: "right-sidebar__qr"
  }, [_c('div', {
    staticClass: "right-sidebar__qr-row"
  }, [_c('button', {
    staticClass: "btn touch",
    on: {
      "click": function click($event) {
        return _vm.$store.commit('property/SET_ACTIVE_VIRTUAL_TOUR_URL', _vm.activeContent.virtualTourUrl);
      }
    }
  }, [_vm._v(_vm._s(_vm.activeContent.virtualTourButtonLabel.en))])])])]) : _vm._e()])], 1), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [_vm.newConfig.general.useSidebarSubnavigation && _vm.$store.getters.activeSidebarSubnavigation.length > 1 ? _c('SidebarSubnavigation', {
    key: "subnav",
    staticClass: "right-sidebar__subnav",
    attrs: {
      "nav-items": _vm.$store.getters.activeSidebarSubnavigation
    }
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [_vm.activeSubsection && _vm.activeSubsection.issuuEmbedUrl[_vm.language.code] ? _c('div', {
    staticClass: "right-sidebar__back-wrapper"
  }, [!_vm.$store.state.actions.showIframeUrl ? _c('button', {
    staticClass: "btn touch",
    on: {
      "click": function click($event) {
        _vm.$store.commit('actions/SET_IFRAME_URL', _vm.activeSubsection.issuuEmbedUrl[_vm.language.code]);
        _vm.$store.commit('sidebar/CLOSE_SLIDEOUT');
      }
    }
  }, [_c('span', [_vm._v("View Brochure")])]) : _c('button', {
    staticClass: "btn touch",
    on: {
      "click": function click($event) {
        return _vm.$store.commit('actions/SET_IFRAME_URL', '');
      }
    }
  }, [_c('span', [_vm._v("Close Brochure")])])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [_vm.activeContent && _vm.activeContent.iframes && _vm.activeContent.iframes[_vm.language.code] && _vm.activeContent.iframes[_vm.language.code].length ? _c('div', {
    staticClass: "right-sidebar__back-wrapper"
  }, _vm._l(_vm.activeContent.iframes[_vm.language.code], function (iframe) {
    return _c('button', {
      key: iframe.url,
      staticClass: "btn touch",
      on: {
        "click": function click($event) {
          _vm.$store.commit('actions/SET_IFRAME_URL', iframe.url);
          _vm.$store.commit('sidebar/CLOSE_SLIDEOUT');
        }
      }
    }, [_c('span', [_vm._v(_vm._s(iframe.label))])]);
  }), 0) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [_vm.activeContent && _vm.activeContent.issuuEmbedUrl ? _c('div', {
    staticClass: "right-sidebar__back-wrapper"
  }, [!_vm.$store.state.actions.showIframeUrl ? _c('button', {
    staticClass: "btn touch",
    on: {
      "click": function click($event) {
        _vm.$store.commit('actions/SET_IFRAME_URL', _vm.activeContent.issuuEmbedUrl);
        _vm.$store.commit('sidebar/CLOSE_SLIDEOUT');
      }
    }
  }, [_c('span', [_vm._v("View Brochure")])]) : _c('button', {
    staticClass: "btn touch",
    on: {
      "click": function click($event) {
        return _vm.$store.commit('actions/SET_IFRAME_URL', '');
      }
    }
  }, [_c('span', [_vm._v("Close Brochure")])])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [(_vm$newConfig$general = _vm.newConfig.general) !== null && _vm$newConfig$general !== void 0 && _vm$newConfig$general.disclaimer ? _c('div', {
    staticClass: "right-sidebar__disclaimer",
    domProps: {
      "innerHTML": _vm._s((_vm$newConfig$general2 = _vm.newConfig.general) === null || _vm$newConfig$general2 === void 0 ? void 0 : _vm$newConfig$general2.disclaimer)
    }
  }) : _vm._e()])], 1), _c('transition', {
    attrs: {
      "name": "sidebar-fade"
    }
  }, [_vm.config.generalSidebarLogo ? _c('div', {
    staticClass: "right-sidebar__logo"
  }, [_vm.isVideo(_vm.config.generalSidebarLogo) ? _c('video', {
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.config.generalSidebarLogo),
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.config.generalSidebarLogo),
      "alt": ""
    }
  })]) : _vm._e()])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }